import type { IconDefinition } from '../index.tsx';

export const iconChevronDown: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconChevronDown',
  icon: [
    16,
    16,
    [],
    '',
    'M15.4144 6.41436L8.00015 13.8286L0.585938 6.41437L3.41436 3.58594L8.00015 8.17172L12.5859 3.58594L15.4144 6.41436Z',
  ],
  fillRule: 'evenodd',
  clipRule: 'evenodd',
};
